import { FileUpload, fileUploadRule } from 'components/FileUpload';
import { Form, Input, Modal, Select, Tag } from 'antd';
import React, { FC } from 'react';

import { CARD_COLORS } from '../../constants';
import { IFormOfferRecommendation } from 'types/recommendations.types';
import { RecommendationsForm } from '../../components/RecommendationsForm';

interface Props<T = IFormOfferRecommendation> {
  onSubmit: (values: T) => Promise<any>;
  visible: boolean;
  initialValues?: object;
  onClose: () => void;
  citiesDisabled?: boolean;
}

export const OfferModal: FC<Props> = ({ onSubmit, visible, initialValues, citiesDisabled, onClose }) => (
  <Modal centered open={visible} onCancel={onClose} footer={[]} destroyOnClose width={'50vw'}>
    <RecommendationsForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      citiesDisabled={citiesDisabled}
      btnText="Добавить"
    >
      <Form.Item label="Заголовок" name="title" rules={[{ required: true }]}>
        <Input.TextArea autoSize placeholder="Введите заголовок" showCount maxLength={50} />
      </Form.Item>
      <Form.Item label="Краткое описание" name="description" rules={[{ required: true }]}>
        <Input.TextArea autoSize placeholder="Введите краткое описание" showCount maxLength={50} />
      </Form.Item>
      <Form.Item label="Полное описание" name="fullDescription" rules={[{ required: true }]}>
        <Input.TextArea autoSize placeholder="Введите полное описание" showCount maxLength={1000} />
      </Form.Item>
      <Form.Item label="Иконка" name="icon" rules={[{ required: true }, fileUploadRule]}>
        {/* @ts-ignore */}
        <FileUpload maxCount={1} name="icon" />
      </Form.Item>
      <Form.Item label="Цвет карточки" name="color" rules={[{ required: true }]}>
        <Select placeholder="Выберите цвет карточки">
          {CARD_COLORS.map((color) => (
            <Select.Option value={color} key={color}>
              <div style={{ display: 'flex', height: '100%', padding: 5 }}>
                <Tag color={color} style={{ width: '100%', height: '100%' }} />
              </div>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </RecommendationsForm>
  </Modal>
);
